<script setup lang="ts">
import { computed } from 'vue';
import { classNames } from '@/js/lib/bem';

const props = withDefaults(
  defineProps<{
    type?: 'button' | 'submit' | 'reset'
    theme?: 'primary' | 'secondary' | 'tertiary' | 'danger'
    size?: 'sm' | 'md'
    disabled?: boolean
    loading?: boolean
    fullWidth?: boolean
  }>(),
  {
    type: 'button',
    theme: 'primary',
    disabled: false,
    loading: false,
    fullWidth: false,
  },
);

const cn = classNames('base-button');

const isDisabled = computed(() => props.disabled || props.loading);

const buttonClasses = computed(() =>
  cn({
    'theme': props.theme,
    'size': props.size ?? null,
    'full-width': props.fullWidth || undefined,
    'loading': props.loading || undefined,
  }),
);
</script>

<template>
  <button
    :type="type"
    :class="buttonClasses"
    :disabled="isDisabled"
    :aria-busy="loading || undefined"
  >
    <span v-if="loading" :class="cn('loader')" aria-hidden="true" />
    <span :class="cn('label', { loading: loading || undefined })">
      <slot />
    </span>
  </button>
</template>

<style lang="scss" scoped>
.base-button {
  &_full-width {
    width: 100%;
    max-width: none;
  }
}
</style>
